export class SelectComponentItemModel {
  public title: string;
  public value: any;

  [ key: string ]: any;
}
